import * as React from "react";
import { cn } from "@/lib/utils";

const CardRow = React.forwardRef(
  ({ className, children, scrollDesktop = false, ...props }, ref) => {
    const layoutClass = scrollDesktop
      ? "flex flex-row gap-4 overflow-x-auto [scroll-snap-type:x_mandatory] pb-2 [-webkit-overflow-scrolling:touch] sm:flex sm:overflow-x-auto sm:space-x-0"
      : "flex flex-row gap-4 overflow-x-auto [scroll-snap-type:x_mandatory] pb-2 [-webkit-overflow-scrolling:touch] sm:grid sm:grid-cols-2 sm:gap-4 sm:space-x-0 sm:overflow-visible xl:grid-cols-3";
    return (
      <div
        ref={ref}
        className={cn(layoutClass, className)}
        {...props}
      >
        {React.Children.map(children, (child) => {
          if (
            React.isValidElement(child) &&
            child.type.displayName &&
            child.type.displayName.includes("Card")
          ) {
            // Clone the card to add scroll-snap and width constraints for mobile/desktop rails.
            return React.cloneElement(child, {
              className: cn(
                "flex-shrink-0 min-w-[86vw] w-[86vw] max-w-[22rem] [scroll-snap-align:start]",
                scrollDesktop
                  ? "sm:w-72 sm:min-w-0 sm:max-w-none sm:flex-shrink-0 sm:[scroll-snap-align:start]"
                  : "sm:flex-initial sm:w-auto sm:min-w-0 sm:max-w-none sm:[scroll-snap-align:none]",
                child.props.className
              ),
            });
          }
          // For non-card children, just return as is
          return child;
        })}
      </div>
    );
  }
);
CardRow.displayName = "CardRow";
export default CardRow;